export default "__VITE_ASSET__Bv1LjMY___"